<template>
    <!-- J1939 (heavy duty) trackers also report the DM1 lamps. Raw values: 0 off, 1 on, 2 error, 3 not available. -->
    <div v-if="lamps" class="d-flex flex-wrap ga-2 my-3">
        <v-chip v-for="lamp in lampDefs"
                :key="lamp.key" size="small"
                :color="lamps[lamp.key] === 1 ? lamp.color : undefined"
                :variant="lamps[lamp.key] === 1 ? 'flat' : 'outlined'">
            {{ lamp.label }}:
            {{ ['Off', 'On', 'Error'][lamps[lamp.key]] ?? 'Not available' }}
        </v-chip>
        <v-chip v-if="lamps.ecus_reporting != null" size="small" variant="outlined">
            ECUs with a lamp lit: {{ lamps.ecus_reporting }}
        </v-chip>
    </div>
</template>

<script setup>
defineProps({
    lamps: {type: Object, default: null},
});

const lampDefs = [
    {key: 'red_stop_lamp', label: 'Red Stop Lamp', color: 'error'},
    {key: 'amber_warning_lamp', label: 'Amber Warning Lamp', color: 'warning'},
    {key: 'protect_lamp', label: 'Protect Lamp', color: 'warning'},
];
</script>
